import { PlanType } from './plan-type';

export enum PlanTypesRanges {
  monthly = 1,
  annual = 12,
}
